module.exports = __webpack_public_path__ + "img/paymo.362a16cc.png";